var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgDropdownIcon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 7,
    height: 4,
    viewBox: "0 0 7 4",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M6.14645 0.146446C6.34171 -0.0488157 6.65829 -0.0488157 6.85355 0.146446C7.04882 0.341709 7.04882 0.658291 6.85355 0.853553L3.85355 3.85355C3.66427 4.04284 3.35947 4.04946 3.16214 3.86858L0.16214 1.11858C-0.041419 0.931981 -0.0551701 0.615697 0.131426 0.412138C0.318022 0.208578 0.634305 0.194827 0.837865 0.381423L3.48496 2.80793L6.14645 0.146446Z",
    fill: "#4F4F4F"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgDropdownIcon);
export default __webpack_public_path__ + "static/media/dropdownIcon.1b6572b84c962576ba5ed3f9828445af.svg";
export { ForwardRef as ReactComponent };